import {
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useEffect, useState } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { formatDate } from "../../../../utility/Index";
import { ShowLoader } from "../../../../common/ShowLoader";
import { base_url, endpoints } from "../../../../Api/configs";
import { toast } from "react-toastify";
import { get } from "react-native/Libraries/TurboModule/TurboModuleRegistry";
import React from "react";
import { getBalance } from "../../../../services/authAPI";
import { buyTicket } from "../../../../services/eventsAPI";
import { handleApiError } from "../../../../services/errorHandler";

export default function GetTicketModal(props) {
  const { showModal = false, setShowModal, details, userData } = props;

  const [promotionCode, setPromotionCode] = useState("");
  const onCloseClick = () => {
    setShowModal(false);
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  const [showLoader, setShowLoader] = useState(false);
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (userData) {
      if (userData.AccessToken) {
        callBalanceApi(userData.AccessToken);
      }
    }
  }, []);

  const callBalanceApi = async (accessToken) => {
    setShowLoader(true);

    try {
      const data = await getBalance(accessToken);
      const responseBody =
        typeof data.body === "string" ? JSON.parse(data.body) : data.body;

      setShowLoader(false);

      if (data.statusCode === 200) {
        if (responseBody.statusCode === 200) {
          if (responseBody.balance) {
            setBalance(responseBody.balance);
          }
        } else {
          toast.error(responseBody.error);
        }
      } else if (data.statusCode === 400) {
        toast.error("Bad Request");
      } else if (data.statusCode > 400 && data.statusCode < 420) {
        toast.error("Unauthorized");
      } else if (data.statusCode >= 500) {
        toast.error("Internal Server Error");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };

  const callGetTicketAPI = async () => {
    if (getAvailableBalance() < 0) {
      toast.error("You don't have enough balance to purchase a ticket");
      return;
    }

    setShowLoader(true);

    const bodyParams = {
      accessToken: userData.AccessToken,
      eventID: details.eventID,
      promotionCode: promotionCode,
    };

    try {
      const response = await buyTicket(bodyParams);
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body)
          : response.body;

      if (response.statusCode === 200) {
        if (responseBody.tokensRemaining) {
          setBalance(responseBody.tokensRemaining);
          setShowModal(false);
          toast.success("Ticket purchased successfully");
        } else {
          handleApiError(response.statusCode, responseBody.error);
        }
      } else {
        handleApiError(response.statusCode, responseBody.error);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setShowLoader(false);
    }
  };

  function getAvailableBalance() {
    let ticketPrice = details && details.ticketPrice ? details.ticketPrice : 0;
    let availableBalance = balance - ticketPrice;
    return availableBalance;
  }
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <View style={styles.mainView}>
          <View
            style={{
              flexDirection: "row",
              paddingTop: 20,
              marginHorizontal: 25,
            }}
          >
            <Text
              style={[
                AppFontStyle.BOLD_ANYBODY_32,
                {
                  flex: 1,
                  alignSelf: "center",
                },
              ]}
            >
              Get tickets
            </Text>
            <View
              style={{
                borderRadius: 10,
                backgroundColor: AppColors.gray_2a2a2a,
                paddingHorizontal: 8,
                paddingVertical: 5,
              }}
            >
              <Ionicons
                name="close"
                size={30}
                color={AppColors.white}
                onPress={onCloseClick}
              />
            </View>
          </View>

          {/* Saprator view */}
          <View
            style={{
              height: 2,
              marginTop: 20,
              backgroundColor: AppColors.appGrayColor_1C1C1C,
              width: "95%",
              marginHorizontal: 25,
            }}
          />

          {/* Main View */}

          <ScrollView
            showsHorizontalScrollIndicator={false}
            showsVerticalScrollIndicator={false}
          >
            {/* <View style={{ flex: 1, paddingBottom: 20 }}> */}
            <View style={styles.mainWrapper}>
              <View style={styles.leftSideWrapper}>
                <View
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                    marginTop: 16,
                  }}
                >
                  <Text style={[AppFontStyle.BOLD_ANYBODY_16]}>
                    {details != null && details.title ? details.title : ""}
                  </Text>
                  <TouchableOpacity
                    activeOpacity={0.7}
                    style={{
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      borderRadius: 7,
                      paddingHorizontal: 25,
                      paddingVertical: 5,
                    }}
                  >
                    <Text style={[AppFontStyle.REGULAR_ANYBODY_12]}>
                      {details != null && details.startDateTime
                        ? formatDate(details.startDateTime)
                        : ""}
                    </Text>
                  </TouchableOpacity>
                </View>

                {/* Stream View  */}
                <View style={styles.streamViewStyle}>
                  <View
                    style={{
                      height: 26,
                      justifyContent: "flex-start",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 8,
                    }}
                  >
                    <View
                      style={{
                        height: 18,
                        width: 18,
                        aspectRatio: 1,
                        backgroundColor: AppColors.appViolentColor_6D08C3,
                        borderRadius: 13,
                      }}
                    />
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        { color: AppColors.white },
                      ]}
                    >
                      Streamer
                    </Text>
                  </View>
                  <View
                    style={{
                      flex: 1,
                    }}
                  ></View>

                  <View
                    style={{
                      justifyContent: "flex-start",
                      alignSelf: "flex-start",
                    }}
                  >
                    <TouchableOpacity
                      activeOpacity={0.7}
                      style={{
                        backgroundColor: AppColors.appViolentColor_6D08C3,
                        borderRadius: 7,
                        paddingHorizontal: 12,
                        paddingVertical: 5,
                      }}
                    >
                      <Text style={[AppFontStyle.REGULAR_ANYBODY_10]}>
                        1.2k Attendees
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
                {/* Decription View */}
                <View style={styles.descriptionText}>
                  <ScrollView>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          padding: 12,
                          color: AppColors.white,
                        },
                      ]}
                    >
                      {details != null && details.description
                        ? details.description
                        : ""}
                    </Text>
                  </ScrollView>
                </View>
              </View>

              <View style={styles.centerDivider} />

              <View
                style={[
                  styles.rightSideWrapper,
                  deviceSize != "extrasmall" && { flex: 1 },
                ]}
              >
                {/* Tokens View */}
                <View
                  style={{
                    backgroundColor: AppColors.appBlackColor_1e1e1e,
                    borderRadius: 10,
                    padding: 12,
                    marginTop: 20,
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_14,
                      {
                        color: AppColors.gray_C3C3C3,
                      },
                    ]}
                  >
                    Jacob's tokens
                  </Text>
                  <Text
                    style={[AppFontStyle.BOLD_ANYBODY_18, { marginTop: 10 }]}
                  >
                    {balance ? balance : 0}
                  </Text>
                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={{
                      alignSelf: "flex-end",
                      backgroundColor: AppColors.appViolentColor_6D08C3,
                      borderRadius: 8,
                      paddingVertical: 5,
                      paddingHorizontal: 10,
                      marginTop: 12,
                    }}
                  >
                    <Text style={[AppFontStyle.BOLD_ANYBODY_12]}>Top-up</Text>
                  </TouchableOpacity>
                </View>

                {/* Promotion code view */}
                <View style={styles.inputWrapper}>
                  <Text
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      styles.headerTitle,
                    ]}
                  >
                    Promotion code
                  </Text>
                  <TextInput
                    placeholder={""}
                    multiline={false}
                    placeholderTextColor={AppColors.white}
                    style={[
                      AppFontStyle.REGULAR_ANYBODY_12,
                      styles.textInputStyle,
                    ]}
                    // ref={refValue}
                    onSubmitEditing={() => {}}
                    onChangeText={setPromotionCode}
                    keyboardType="default"
                    secureTextEntry={false}
                    value={promotionCode}
                  />
                </View>

                {/* Total View */}
                <View
                  style={{
                    flex: 1,
                    justifyContent: "flex-end",
                    marginTop: 25,
                  }}
                >
                  {/* Total price View */}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Ticket price
                    </Text>
                    <Text style={[AppFontStyle.BOLD_ANYBODY_16]}>
                      {details && details.ticketPrice ? details.ticketPrice : 0}
                    </Text>
                  </View>
                  {/* Balance View */}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Balance
                    </Text>
                    <Text style={[AppFontStyle.BOLD_ANYBODY_16]}>
                      {balance ? balance : 0}
                    </Text>
                  </View>

                  <View
                    style={{
                      height: 2,
                      marginTop: 10,
                      backgroundColor: AppColors.appGrayColor_1C1C1C,
                      width: "100%",
                    }}
                  />

                  {/* Balance remaining  View*/}
                  <View
                    style={{
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  >
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_12,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      Balance remaining
                    </Text>
                    <Text
                      style={[
                        AppFontStyle.REGULAR_ANYBODY_14,
                        {
                          color: AppColors.gray_C3C3C3,
                        },
                      ]}
                    >
                      {getAvailableBalance()}
                    </Text>
                  </View>

                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={{
                      alignSelf: "flex-end",
                      backgroundColor: AppColors.appGreenColor_51AF07,
                      borderRadius: 8,
                      paddingVertical: 8,
                      paddingHorizontal: 14,
                      marginTop: 16,
                      marginBottom: 20,
                    }}
                    onPress={() => {
                      callGetTicketAPI();
                    }}
                  >
                    <Text style={[AppFontStyle.BOLD_ANYBODY_12]}>Purchase</Text>
                  </TouchableOpacity>
                </View>
              </View>
              {/* <View style={styles.rightSideWrapper}>
                                <View style={styles.rightSideMainView}>
                                    
                                </View>
                            </View> */}
              {/* </View> */}
            </View>
          </ScrollView>
        </View>
        {<ShowLoader showIndicater={showLoader} />}
      </View>
    </Modal>
  );
}

// const styles = StyleSheet.create({
const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
    },
    mainView: {
      width: "50%",
      backgroundColor: AppColors.black_121212,
      margin: 30,
      alignSelf: "center",
      borderRadius: 12,
    },
    mainWrapper: {
      flex: 1,
      flexDirection: "row",
    },
    leftSideWrapper: {
      flex: 1,
      marginHorizontal: 25,
    },
    rightSideWrapper: {
      marginHorizontal: 25,
    },
    streamViewStyle: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderRadius: 10,
      paddingVertical: 9,
      paddingHorizontal: 11,
      gap: 10,
      height: 200,
      marginTop: 16,
    },
    inputWrapper: {
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      paddingHorizontal: 12,
      borderRadius: 10,
      marginTop: 12,
    },
    headerTitle: {
      color: AppColors.gray_C3C3C3,
      paddingTop: 10,
    },
    textInputStyle: {
      paddingTop: 5,
      paddingBottom: 18,
      color: AppColors.white,
      flex: 1,
      outlineStyle: "none",
    },
    centerDivider: {
      height: "100%",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: 2,
    },
    descriptionText: {
      marginTop: 20,
      height: 300,
      marginBottom: 20,
    },
    rightSideMainView: {
      flex: 1,
      marginVertical: 16,
    },
  },
  {
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      mainWrapper: {
        flex: 1,
        flexDirection: "row",
      },
      leftSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      rightSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
        marginTop: 16,
      },
      inputWrapper: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 12,
        borderRadius: 10,
        marginTop: 12,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      centerDivider: {
        height: "100%",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 2,
      },
    },
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "70%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      mainWrapper: {
        flex: 1,
        flexDirection: "row",
      },
      leftSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      rightSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
        marginTop: 16,
      },
      inputWrapper: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 12,
        borderRadius: 10,
        marginTop: 12,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      centerDivider: {
        height: "100%",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 2,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      mainWrapper: {
        flex: 1,
        flexDirection: "row",
      },
      leftSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      rightSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 250,
        marginTop: 16,
      },
      inputWrapper: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 12,
        borderRadius: 10,
        marginTop: 12,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      centerDivider: {
        height: "100%",
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: 2,
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
      },
      mainView: {
        width: "90%",
        height: "90%",
        backgroundColor: AppColors.black_121212,
        margin: 30,
        alignSelf: "center",
        borderRadius: 12,
      },
      mainWrapper: {
        flex: 1,
        flexDirection: "column",
      },
      leftSideWrapper: {
        flex: 1,
        marginHorizontal: 25,
      },
      rightSideWrapper: {
        marginHorizontal: 25,
      },
      streamViewStyle: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        borderRadius: 10,
        paddingVertical: 9,
        paddingHorizontal: 11,
        gap: 10,
        height: 200,
        marginTop: 16,
      },
      inputWrapper: {
        backgroundColor: AppColors.appBlackColor_1e1e1e,
        paddingHorizontal: 12,
        borderRadius: 10,
        marginTop: 12,
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 10,
      },
      textInputStyle: {
        paddingTop: 5,
        paddingBottom: 18,
        color: AppColors.white,
        flex: 1,
      },
      centerDivider: {
        height: 2,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "90%",
        alignSelf: "center",
      },
      descriptionText: {
        marginTop: 20,
        height: 300,
        marginBottom: 20,
      },
      rightSideMainView: {
        flex: 1,
        marginVertical: 16,
      },
    },
  }
);
